import { useTheme } from '@emotion/react';
import { IconBadge } from '../IconBadge/index.js';
import { FILE_ICON_MAP } from './constants.js';
import { jsx } from '@emotion/react/jsx-runtime';

function getIcon(extension) {
  for (const category in FILE_ICON_MAP) {
    if (Object.prototype.hasOwnProperty.call(FILE_ICON_MAP, category)) {
      const categoryExtensions = FILE_ICON_MAP[category].extensions;
      if (categoryExtensions.includes(extension)) {
        return {
          type: category,
          icon: FILE_ICON_MAP[category].icon
        };
      }
    }
  }
  return {
    type: 'default',
    icon: FILE_ICON_MAP.default.icon
  };
}
const FileIcon = ({
  extension,
  size = 'lg'
}) => {
  const {
    colorScheme
  } = useTheme();
  const {
    type,
    icon
  } = getIcon(extension);
  return jsx(IconBadge, {
    backgroundColor: colorScheme.file[type].background,
    color: colorScheme.file[type].content,
    size: size,
    icon: icon
  });
};
FileIcon.displayName = 'FileIcon';

export { FileIcon };
